/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../Core/Image';
import play from '../../../images/playButton.svg';
import pause from '../../../images/pauseButton.svg';
import ptsPuck from '../../../images/pts-icon.svg';
import ptsPuckBlack from '../../../images/PTS-bubble-black.svg';
import ptsPuckWhite from '../../../images/pts-bubble-white.svg';

import {
  PHXLaunchWrapperStyles,
  PHXLaunchContentStyles,
  PHXLaunchTitleStyles,
  PHXLaunchIntroStyles,
  PHXLaunchCTAWrapperStyles,
  PHXLaunchMediaContainerStyles,
} from './VariationStyles/phx-launch-campaign-styles';
import {
  OptimumCircleVariationsWrapperStyles,
  OptimumCircleVariationsContentStyles,
  OptimumCircleVariationsTitleStyles,
  OptimumCircleVariationsIntroStyles,
  OptimumCircleVariationsCTAWrapperStyles,
  OptimumCircleVariationsMediaContainerStyles,
  OptimumCircleVariationsHeroImageStyles,
} from './VariationStyles/optimum-circle-variation-styles.js';
import {
  OptimumHeroVariationsWrapperStyles,
  OptimumHeroVariationsContentStyles,
  OptimumHeroVariationsTitleStyles,
  OptimumHeroVariationsIntroStyles,
  OptimumHeroVariationsCTAWrapperStyles,
  OptimumHeroVariationsMediaContainerStyles,
  OptimumHeroVariationsHeroImageStyles,
} from './VariationStyles/optimum-hero-variation-styles.js';
import {
  PCMAWrapperStyles,
  PCMAContentStyles,
  PCMATitleStyles,
  PCMAIntroStyles,
  PCMACTAWrapperStyles,
  PCMAMediaContainerStyles,
  PCMAHeading,
} from './VariationStyles/pcma-styles';
import {
  DigitalBankingWrapperStyles,
  DigitalBankingTitleStyles,
  DigitalBankingIntroStyles,
  DigitalBankingMediaContainerStyles,
  DigitalBankingHeroImageStyles,
} from './VariationStyles/digital-banking-styles';
import {
  EssoCampaignHeroVariationsWrapperStyles,
  EssoCampaignHeroVariationsContentStyles,
  EssoCampaignHeroVariationsTitleStyles,
  EssoCampaignHeroVariationsIntroStyles,
  EssoCampaignHeroVariationsCTAWrapperStyles,
  EssoCampaignHeroVariationsMediaContainerStyles,
  EssoCampaignHeroVariationsHeroImageStyles,
} from './VariationStyles/esso-campaign-hero-variation-styles.js';
import {
  PageNotFoundWrapperStyles,
  PageNotFoundContentStyles,
  PageNotFoundIntroStyles,
  PageNotFoundMediaContainerStyles,
  PageNotFoundHeroImageStyles,
} from './VariationStyles/page-not-found-styles';
import {
  AdventCalendarVariationsWrapperStyles,
  AdventCalendarVariationsContentStyles,
  AdventCalendarVariationsTitleStyles,
  AdventCalendarVariationsIntroStyles,
  AdventCalendarVariationsCTAWrapperStyles,
  AdventCalendarVariationsMediaContainerStyles,
  AdventCalendarVariationsHeroImageStyles,
} from './VariationStyles/advent-calendar-styles';
import {
  StaticBackgroundOverflowWrapperStyles,
  StaticBackgroundOverflowContentStyles,
  StaticBackgroundOverflowHeadingStyles,
  StaticBackgroundOverflowIntroStyles,
  StaticBackgroundOverflowMediaContainerStyles,
  StaticBackgroundOverflowHeroImageStyles,
} from './VariationStyles/static-with-background-overflow';

export const Wrapper = styled.div`
  position: relative;
  gap: 1rem;
  padding: 0.25rem 0 0.25rem;
  background-color: ${props =>
    props.backgroundColor
      ? themeGet(`colors.${props.backgroundColor}`)
      : 'transparent'};
  background-image: ${props =>
    props.assetPosition === false && props.image
      ? `url(${props.image})`
      : null};
  background-size: ${props =>
    props.assetPosition === false
      ? Array.isArray(props.bgSize) === true
        ? `${props.bgSize[0]}%`
        : 'cover'
      : null};
  background-position: ${props =>
    props.assetPosition === false ? 'top right' : null};
  background-repeat: ${props =>
    props.assetPosition === false ? 'no-repeat' : null};
  color: ${props =>
    props.contentColor === 'velvet'
      ? themeGet('colors.white')
      : props.contentColor === 'pc-red'
        ? themeGet('colors.white')
        : themeGet('colors.main-text')};

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 1rem 0 1rem;
    background-size: ${props =>
      props.assetPosition === false
        ? Array.isArray(props.bgSize) === true
          ? `${props.bgSize[1]}%`
          : 'cover'
        : null};
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 2.5rem 0 2.5rem;
    background-size: ${props =>
      props.assetPosition === false
        ? Array.isArray(props.bgSize) === true
          ? `${props.bgSize[2]}%`
          : 'cover'
        : null};
  }

  /* EXAMPLE - VARIATION BEING USED ON THE CREDIT CARD DETAIL PAGES */
  &.hero-variation-3 {
    display: flex;
    flex-direction: column-reverse;

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      flex-direction: row-reverse;
    }
  }

  /* EXAMPLE - VARIATION BEING USED ON THE LOYALTY PAGE (OPTIMUM) */
  &.hero-variation-5 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
  }

  ${PHXLaunchWrapperStyles};
  ${OptimumCircleVariationsWrapperStyles};
  ${OptimumHeroVariationsWrapperStyles};
  ${PCMAWrapperStyles};
  ${DigitalBankingWrapperStyles};
  ${EssoCampaignHeroVariationsWrapperStyles};
  ${PageNotFoundWrapperStyles};
  ${AdventCalendarVariationsWrapperStyles};
  ${StaticBackgroundOverflowWrapperStyles};
`;

export const Content = styled.div`
  justify-content: center;
  align-content: center;
  background-color: ${props =>
    props.contentBackgroundColor
      ? themeGet(`colors.${props.contentBackgroundColor}`)
      : 'transparent'};
  color: ${props =>
    props.contentColor
      ? props.contentColor === 'velvet'
        ? themeGet('colors.white')
        : props.contentColor === 'pc-red'
          ? themeGet('colors.white')
          : themeGet('colors.main-text')
      : 'inherit'};

  text-align: ${({ $textAlignment }) => $textAlignment || 'left'};

  ${Wrapper}.hero-variation-3 & {
    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      width: 100%;
      max-width: 812px;
    }
  }

  ${Wrapper}.hero-variation-5 & {
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-right: 25px;
    }
  }

  ${Wrapper}.esso-banner & {
    text-align: center;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      text-align: left;
    }
  }

  ${PHXLaunchContentStyles};
  ${OptimumCircleVariationsContentStyles};
  ${OptimumHeroVariationsContentStyles};
  ${PCMAContentStyles};
  ${EssoCampaignHeroVariationsContentStyles};
  ${PageNotFoundContentStyles};
  ${AdventCalendarVariationsContentStyles};
  ${StaticBackgroundOverflowContentStyles};
`;

export const Title = styled.h1`
  font-weight: ${themeGet('fontWeights.medium')};
  color: inherit;
  font-size: 1.5rem;
  line-height: 2.5rem;
  letter-spacing: -0.25px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 2.5rem;
    line-height: 120%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-size: 2.5rem;
    line-height: 120%;
  }

  ${Wrapper}.hero-variation-3 & {
    font-size: 2.5rem;
    line-height: 1.11;
    letter-spacing: -0.2px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 54px;
      line-height: 1.11;
      letter-spacing: -0.3px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 75px;
      line-height: 1.1;
      letter-spacing: -0.39px;
    }
  }

  ${Wrapper}.hero-variation-5 & {
    font-size: ${({ lang }) => (lang === 'en' ? '36px' : '32px')};
    line-height: 40px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: ${({ lang }) => (lang === 'en' ? '54px' : '38px')};
      line-height: ${({ lang }) => (lang === 'en' ? '60px' : '52px')};
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: ${({ lang }) => (lang === 'en' ? '96px' : '64px')};
      line-height: ${({ lang }) => (lang === 'en' ? '106px' : '76px')};
    }
  }

  + a,
  button {
    margin-top: 30px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-top: 35px;
    }
  }

  span.points {
    font-size: inheirt;
    font-weight: 600;
    letter-spacing: -1px;
    margin-top: 0.3rem;
    position: relative;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-top: 0;
    }

    &:after {
      content: '';
      display: inline-block;
      background-image: url(${ptsPuck});
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      height: 1.8rem;
      width: 1.8rem;
      margin-left: 0.2rem;
      vertical-align: top;

      @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
        width: 2rem;
        height: 2rem;
      }
    }

    &.pts-black {
      &:after {
        background-image: url(${ptsPuckBlack});
      }
    }
    &.pts-white {
      &:after {
        background-image: url(${ptsPuckWhite});
      }
    }
  }

  ${PHXLaunchTitleStyles};
  ${OptimumCircleVariationsTitleStyles};
  ${OptimumHeroVariationsTitleStyles};
  ${PCMATitleStyles};
  ${DigitalBankingTitleStyles};
  ${EssoCampaignHeroVariationsTitleStyles};
  ${AdventCalendarVariationsTitleStyles};
`;

export const PointsContainer = styled.span`
  color: ${props =>
    props.$ptsColor ? themeGet(`colors.${props.$ptsColor}`) : 'inherit'};
  font-weight: inherit;
  font-stretch: inherit;
  font-style: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  font-size: inherit;

  ${Content}.iol & {
    font-weight: ${themeGet('fontWeights.medium')};
  }
`;
export const Intro = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 35px 0;
  color: inherit;

  p {
    color: inherit;
  }

  ${Wrapper}.static-full-width-content & {
    max-width: none;
  }

  ${PHXLaunchIntroStyles};
  ${OptimumCircleVariationsIntroStyles};
  ${OptimumHeroVariationsIntroStyles};
  ${PCMAIntroStyles};
  ${DigitalBankingIntroStyles};
  ${EssoCampaignHeroVariationsIntroStyles};
  ${PageNotFoundIntroStyles};
  ${AdventCalendarVariationsIntroStyles};
  ${StaticBackgroundOverflowIntroStyles};
`;

export const SubHead = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 1.25rem 0 0;
  color: inherit;

  p {
    color: inherit;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin: 2rem 0 0;
  }

  ${Wrapper}.static-full-width-content & {
    max-width: none;
    p {
      font-size: 1.25rem;
    }
  }

  ${PHXLaunchIntroStyles};
  ${OptimumCircleVariationsIntroStyles};
  ${OptimumHeroVariationsIntroStyles};
  ${PCMAIntroStyles};
  ${DigitalBankingIntroStyles};
  ${EssoCampaignHeroVariationsIntroStyles};
  ${PageNotFoundIntroStyles};
  ${AdventCalendarVariationsIntroStyles};
  ${StaticBackgroundOverflowIntroStyles};
`;

export const CTAWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: ${({ $ctaAlignment }) => $ctaAlignment || 'flex-start'};
  margin-top: 2rem;
  gap: 1.5rem;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-top: 2.5rem;
  }

  ${Wrapper}.pcma-hero & {
    margin-top: 1.5rem;

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      margin-top: 2rem;
    }
  }

  ${Wrapper}.esso-banner & {
    a {
      margin: 0 auto;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      a {
        margin: unset;
        margin-bottom: 2rem;
      }
    }
  }

  ${Wrapper}.static-404 & {
    flex-direction: row;
    justify-content: start;
  }

  ${PHXLaunchCTAWrapperStyles};
  ${OptimumCircleVariationsCTAWrapperStyles};
  ${OptimumHeroVariationsCTAWrapperStyles};
  ${PCMACTAWrapperStyles};
  ${EssoCampaignHeroVariationsCTAWrapperStyles};
  ${AdventCalendarVariationsCTAWrapperStyles};
`;

export const MediaContainer = styled.div`
  position: relative;
  margin: 0 calc(-${themeGet('media.grid-gutter.2')} / 2);
  margin-top: 35px;

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    margin: 0 calc(-${themeGet('media.grid-gutter.3')} / 2);
    margin-top: 40px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
    margin: 0;
    margin-top: 50px;
  }

  ${Wrapper}.hero-variation-3 & {
    margin: 0 auto;
    margin-bottom: 35px;
    width: 100%;
    max-width: 280px;

    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
      margin: 0 auto;
      margin-bottom: 40px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 0 auto;
      margin-bottom: 50px;
      max-width: 320px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      margin: 0 auto 0 0;
      max-width: 377px;
    }
  }

  ${Wrapper}.hero-variation-5 & {
    @media only screen and (max-width: ${themeGet('breakpoints.md')}) {
      width: 100vw;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-top: 0;
      width: auto;
    }
  }

  ${PHXLaunchMediaContainerStyles};
  ${OptimumCircleVariationsMediaContainerStyles};
  ${OptimumHeroVariationsMediaContainerStyles};
  ${PCMAMediaContainerStyles};
  ${DigitalBankingMediaContainerStyles};
  ${EssoCampaignHeroVariationsMediaContainerStyles};
  ${PageNotFoundMediaContainerStyles};
  ${AdventCalendarVariationsMediaContainerStyles};
  ${StaticBackgroundOverflowMediaContainerStyles};
`;

export const HeroImage = styled(Image)`
  height: 270px;
  width: 100%;
  object-fit: ${({ $objectFit }) => $objectFit || 'cover'};

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    height: 501px;
  }

  ${Wrapper}.hero-variation-3 & {
    height: 183px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      height: 209px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      height: 247px;
    }
  }

  ${Wrapper}.hero-variation-5 & {
    height: auto;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 372px;
      height: 326px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      width: 625px;
      height: 549px;
    }
  }

  ${OptimumCircleVariationsHeroImageStyles};
  ${OptimumHeroVariationsHeroImageStyles};
  ${DigitalBankingHeroImageStyles};
  ${EssoCampaignHeroVariationsHeroImageStyles};
  ${PageNotFoundHeroImageStyles};
  ${AdventCalendarVariationsHeroImageStyles};
  ${StaticBackgroundOverflowHeroImageStyles};
`;

export const Heading = styled.div`
  color: inherit;

  ${PCMAHeading};
  ${StaticBackgroundOverflowHeadingStyles};
`;

export const Points = styled.h1`
  font-weight: ${themeGet('fontWeights.bold')};
  color: inherit;
  font-stretch: normal;
  font-style: normal;
  line-height: 120%;
  letter-spacing: -2px;
  font-size: 1.5rem;

  .pts-bubble {
    height: 23px;
    width: 32px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 2.5rem;
  }
`;

export const PreTitle = styled.span`
  font-weight: ${themeGet('fontWeights.medium')};
  color: inherit;
  font-size: 1.4rem;
  display: block;
  width: 100%;
  line-height: 130%;
  margin-bottom: 0.5rem;

  sup {
    font-size: 75%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    font-size: 1.45rem;
  }

  @media only screen and (min-width: 480px) {
    font-size: 1.8rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 1.8rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-size: 2rem;
  }

  ${Content}.iol & {
    font-size: 2rem;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 2.5rem;
    }
  }
`;

export const SubTitle = styled.p`
  font-weight: ${themeGet('fontWeights.medium')};
  color: inherit;
  font-size: 1.25rem;
  line-height: 130%;

  sup {
    font-size: 75%;
  }

  a {
    color: inherit;
  }
`;

export const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  justify-content: center;

  video {
    @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
      border: 1px solid transparent;
      border-radius: 1.5rem;
    }
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
    height: 100%;
  }
`;

export const PausePlayBtn = styled.button`
  background: center / contain no-repeat
    url(${({ playing }) => (playing ? pause : play)});
  position: absolute;
  height: 48px;
  width: 48px;
  bottom: 1rem;
  left: 1rem;

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    bottom: 1.5rem;
    left: 1.5rem;
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.xlg}) {
    bottom: 2rem;
    left: 2rem;
  }
`;
